module.exports = __webpack_public_path__ + "amcharts/images/eraserIconH.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/eraserIconH.svg
// module id = 267
// module chunks = 0